import * as jsxRuntime from "/builds/tbrain-ru/baas/baas-client-front/node_modules/react/jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment